import { createHashHistory, createBrowserHistory } from 'history';

const history =
  process.env.REACT_APP_STATIC === 'static'
    ? createHashHistory()
    : createBrowserHistory();

export default history;
